var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 7.29163,
    r: 0.625,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.4202C11.25 10.0059 10.9142 9.67016 10.5 9.67016C10.0858 9.67016 9.75 10.0059 9.75 10.4202H11.25ZM9.75 12.9202C9.75 13.3344 10.0858 13.6702 10.5 13.6702C10.9142 13.6702 11.25 13.3344 11.25 12.9202H9.75ZM17.25 10C17.25 13.7279 14.2279 16.75 10.5 16.75V18.25C15.0563 18.25 18.75 14.5563 18.75 10H17.25ZM10.5 16.75C6.77208 16.75 3.75 13.7279 3.75 10H2.25C2.25 14.5563 5.94365 18.25 10.5 18.25V16.75ZM3.75 10C3.75 6.27208 6.77208 3.25 10.5 3.25V1.75C5.94365 1.75 2.25 5.44365 2.25 10H3.75ZM10.5 3.25C14.2279 3.25 17.25 6.27208 17.25 10H18.75C18.75 5.44365 15.0563 1.75 10.5 1.75V3.25ZM9.75 10.4202V12.9202H11.25V10.4202H9.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.31770341c1793166f8ab6c898fd5fbba.svg";
export { ForwardRef as ReactComponent };